import { useEffect } from "react"
import { useQueryClient } from "@tanstack/react-query"
import { useNavigate } from "react-router-dom"
import { toast } from "sonner"

import { assinarNotificacoes } from "@/lib/notificacoesApi"

/**
 * Mantém o push de notificações conectado enquanto o usuário está autenticado.
 * Cada evento invalida a caixa e, para notificações novas, exibe um toast com
 * atalho para a entidade relacionada.
 */
export function useNotificacoesPush() {
  const queryClient = useQueryClient()
  const navigate = useNavigate()

  useEffect(() => {
    const controller = new AbortController()
    let ativo = true
    let tentativa = 0

    async function conectar() {
      while (ativo) {
        try {
          await assinarNotificacoes(controller.signal, (notificacao, tipo) => {
            tentativa = 0
            void queryClient.invalidateQueries({ queryKey: ["notificacoes"] })
            if (tipo !== "nova") return

            const entidadeId = notificacao.entidadeId
            toast.info(notificacao.titulo, {
              description: notificacao.corpo ?? undefined,
              action:
                notificacao.entidadeTipo === "FORMULARIO_RESPOSTA" && entidadeId
                  ? {
                      label: "Abrir",
                      onClick: () => navigate(`/formularios/respostas/${entidadeId}`),
                    }
                  : undefined,
            })
          })
        } catch {
          if (!ativo || controller.signal.aborted) return
        }

        if (!ativo) return
        const espera = Math.min(30_000, 1000 * 2 ** tentativa)
        tentativa = Math.min(tentativa + 1, 5)
        await new Promise((resolve) => setTimeout(resolve, espera))
      }
    }

    void conectar()
    return () => {
      ativo = false
      controller.abort()
    }
  }, [navigate, queryClient])
}
